export default __webpack_public_path__ + "9f11d076a3d8a5cd1fda31ca5bee3beb.png";